/**
 * B653 (c) — the foot's left line (553:2): "Stand Up Live · 50 W. Jefferson
 * St, Phoenix · (480) 719-6100 · Validated parking under the club, 3 hours
 * free". The business name, then where guests find the venue, dot-joined;
 * what the tenant never stored is dropped, and nothing stored is no line.
 */

/** The venue facts the guest mint carries beside the business name (ops-config's own). */
export interface VenueFacts {
  readonly venueAddress?: string;
  readonly venuePhone?: string;
  readonly venueNote?: string;
}

export function footFacts(businessName: string | undefined, venue: VenueFacts): string | undefined {
  const parts = [businessName, venue.venueAddress, venue.venuePhone, venue.venueNote]
    .map((p) => p?.trim() ?? "")
    .filter((p) => p !== "");
  return parts.length === 0 ? undefined : parts.join(" · ");
}
